import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { useLayerCountsQuery } from "@/v2-backoffice-client/layer/counts/layer.counts.query"

export type LayerReviewCountBadgeProps = ComponentProps<"span">

/**
 * Pending-review counter for the sidebar Layers item: a small iOS-style red
 * circle with the count. Renders nothing while loading or when the queue is
 * empty, so the sidebar stays quiet by default.
 */
function LayerReviewCountBadge(props: LayerReviewCountBadgeProps) {
  const { className, ...spanProps } = props

  const { data } = useLayerCountsQuery()
  const count = data?.getLayerCounts.PendingReview ?? 0

  if (count === 0) return null

  return (
    <span
      className={cn(
        "layer-review-count-badge",
        "inline-flex items-center justify-center h-4 min-w-4 px-px rounded-full",
        "bg-destructive text-destructive-foreground",
        "text-[8px] font-semibold leading-none tabular-nums",
        className,
      )}
      {...spanProps}
    >
      {count > 99 ? "99+" : count}
    </span>
  )
}

export default LayerReviewCountBadge
